export const revolution_shorts = {
  msrp: 34.99,
  infoLink: 'https://www.teamtriton.com/revolution-shorts.html',
  items: [
    {
      number: 'RV100',
      hasModel: false,
    },
    {
      number: 'RV101',
      hasModel: false,
    },
    {
      number: 'RV102',
      hasModel: false,
    },
    {
      number: 'RV103',
      hasModel: false,
    },
    {
      number: 'RV104',
      hasModel: false,
    },
    {
      number: 'RV105',
      hasModel: false,
    },
    {
      number: 'RV106',
      hasModel: false,
    },
    {
      number: 'RV107',
      hasModel: false,
    },
    {
      number: 'RV108',
      hasModel: false,
    },
    {
      number: 'RV109',
      hasModel: false,
    },
    {
      number: 'RV110',
      hasModel: false,
    },
    {
      number: 'RV111',
      hasModel: false,
    },
    {
      number: 'RV112',
      hasModel: false,
    },
    {
      number: 'RV113',
      hasModel: false,
    },
    {
      number: 'RV114',
      hasModel: false,
    },
    {
      number: 'RV115',
      hasModel: false,
    },
  ],
};
